import idx from 'idx';
// @ts-ignore TODO: convert this file
import Config from 'Config';
import { once } from 'lodash';
// @ts-ignore TODO: convert this file
import { emitter } from '../emitter';
import { ApolloLink, Operation, split } from 'apollo-link';
import ApolloClient from 'apollo-client';
import { getMainDefinition } from 'apollo-utilities';
import { WebSocketLink } from 'apollo-link-ws';
import { createHttpLink } from 'apollo-link-http';
// @ts-ignore TODO: convert this file
import { newInMemoryCache } from 'lib/apollo/cache/memory';
// @ts-ignore TODO: convert this file
import { getCommonHeaders, getCsrfTokenFromCookies } from 'lib/requestHeaders';
import {
  ApplicationContextLink,
  NetworkErrorLink,
  QueryErrorLink,
  LogQueryLink,
  RetryLink,
  // @ts-ignore TODO: convert this file
} from 'lib/apollo/links';
import { OperationDefinitionNode } from 'graphql';

/* The application context link is responsible for
 * adding any kind of stuff into the request context.
 */
const applicationContextLink = new ApplicationContextLink({
  getHeaders: () => getCommonHeaders(getCsrfTokenFromCookies()),
  getTimeout: () => 5000,
});

/* The network error link is responsible for surfacing any
 * network errors between the browser and the apollo server
 *
 * See lib/apolloErrorListener.js
 */
const networkErrorLink = new NetworkErrorLink({
  status: {
    '*': (code: string) => {
      emitter.emit(`network_error.${code}`);
    },
  },
});

/* The query error link is responsible for surfacing any
 * HTTP errors that occured during the execution of the query on the server.
 * For example, If the graphql server uses a downstream services that returns a 503,
 * and the graphql server does not catch/handle that error, the errors will surface here.
 *
 * See lib/apolloErrorListener.js
 */
const queryErrorLink = new QueryErrorLink({
  status: {
    '*': (codes: string[]) => {
      for (const code of codes) {
        emitter.emit(`query_error.${code}`);
      }
    },
  },
});

/* The retry link is responsible for retrying any
 * operations allowed by the shouldRetry predicate
 * function that failed because of a query or network error.
 *
 * See lib/apollo/links/RetryLink.js
 */
const retryLink = new RetryLink({
  shouldRetry: (operation: Operation, errors: any[]) => {
    const { operationName } = operation;
    if (operationName === 'ContentSourcesContent') {
      return !!errors.find(e => idx(e, _ => _.serviceMetadata.service_status) === 503);
    }
    return false;
  },
});

export const getApolloClientSingleton: () => ApolloClient<any> = once(() => {
  /* The HTTP link is the terminating link of the chain.
   * It must always to placed last as it does not forward the
   * operation, but transforms the operation into an observable result.
   *
   * This is inside getApolloClientSingleton() because this browser.js file
   * is imported even in server side rendering ... and it crashed
   * because there's no global.fetch.
   */
  const httpLink = createHttpLink({
    uri: `${Config.Environment.R101_API_URL}/graphql`,
  });

  // TODO: this will currently only work locally if you have a local Apollo
  // server running at localhost:8082. pow does not support websockets, so
  // a nontrivial amount of work is needed to proxy ws://www.remind.localhost
  // correctly to point to an environment variable
  const wsLink = new WebSocketLink({
    uri: Config.Environment.R101_SUBSCRIPTIONS_URL,
    options: {
      reconnect: true,
      lazy: true,
      inactivityTimeout: 60,
    },
  });

  const link = split(
    ({ query }) => {
      const { kind, operation } = getMainDefinition(query as any) as OperationDefinitionNode;
      return kind === 'OperationDefinition' && operation === 'subscription';
    },
    (wsLink as unknown) as ApolloLink,
    httpLink
  );

  const cache = newInMemoryCache();

  // restore the cache from the possible server side rendering.
  if (typeof window !== 'undefined') {
    const data = idx(window as any, _ => _.initialAppData.apolloData);

    if (data) {
      cache.restore(data);
    }
  }

  return new ApolloClient({
    cache,
    link: ApolloLink.from([
      new LogQueryLink(),
      applicationContextLink,
      queryErrorLink,
      networkErrorLink,
      retryLink,
      link,
    ]),
  });
});
